import { buildAppUrl, getCurrentTenantSubdomain } from '@/utils/app-domain';

import type { SocialProvider } from './outcome';

/**
 * Every provider this instance exchanges with answers a sign-in only from an origin registered in
 * its own console - Google's and Apple's client registrations, Entra's SPA redirect-URI allowlist -
 * and none of them takes a wildcard. Tenant subdomains are an unbounded set, so every social
 * tap on the vadio domain runs on the tenant-less entry host `app.<domain>`: login and signup
 * leave a tenant host before they render, and the Connected accounts card sends a connect to
 * `/link-account` there. A custom domain is registered one by one before it goes live
 * (release-checklist.md, "Origins to register") and stays in place.
 */

export const LINK_ACCOUNT_PATH = '/link-account';

/** True on a tenant subdomain of the vadio domain, where no provider will answer. */
export const isUnregisteredTenantHost = (): boolean =>
	import.meta.env.VITE_APP_ENV !== 'e2e' && getCurrentTenantSubdomain() !== null;

/** The page being loaded, moved to the entry host, or null where it can stay. */
export const appOriginUrlForCurrentPage = (): string | null => {
	if (!isUnregisteredTenantHost()) return null;
	const { pathname, search, hash } = window.location;
	return buildAppUrl(`${pathname}${search}${hash}`);
};

export interface LinkAccountUrlInput {
	provider: SocialProvider;
	/** Where the connect page sends the User once the provider is attached; a vadio-domain URL. */
	returnTo: string;
}

/** The connect page on the entry host, carrying the way back to the workspace. */
export const linkAccountUrl = ({ provider, returnTo }: LinkAccountUrlInput): string =>
	buildAppUrl(`${LINK_ACCOUNT_PATH}?${new URLSearchParams({ provider, return: returnTo })}`);
